module.exports = __webpack_public_path__ + "static/media/low_mid_freq.42d52172.png";